
<template>
  <div>
  <v-dialog v-model="isModalShowing" persistent width="530">
    <template v-slot:activator="{ on }">
        <span v-on="on">
            <slot />
        </span>
    </template>
    <v-card data-test="call-list-modal">
      <v-card-text class="message-type-section">
        <div class="message-type-container">
          <label class="message-type-option" :class="{ active: messageTypeSelection === 'link' }">
              <input 
                  type="radio" 
                  name="messageType" 
                  v-model="messageTypeSelection"
                  value="link"
                  class="message-type-radio"
              >
              <span class="message-type-label">{{ $t('modals.findByListModal.byLink') }}</span>
          </label>
          <label v-show="teamId === 1" class="message-type-option" :class="{ active: messageTypeSelection === 'alert' }">
              <input 
                  type="radio" 
                  name="messageType" 
                  v-model="messageTypeSelection"
                  value="alert"
                  class="message-type-radio"
              >
              <span class="message-type-label">{{ $t('modals.findByListModal.byAlert') }}</span>
          </label>
          <!-- <label class="message-type-option" :class="{ active: messageTypeSelection === 'response' }">
              <input 
                  type="radio" 
                  name="messageType" 
                  v-model="messageTypeSelection"
                  value="response"
                  class="message-type-radio"
              >
              <span class="message-type-label">{{ $t('modals.findByNumbersModal.byResponse') }}</span>
          </label> -->
          <v-select
            v-model="picked"
            :items="languageItems"
            item-text="text"
            item-value="value"
            rounded
            filled
            dense
            hide-details
            style="max-width: 120px; font-size: 12px; margin-left: auto;"
          ></v-select>
          <v-select
            v-show="messageTypeSelection === 'link'"
            v-model="smsContentValue"
            :items="smsContentItems"
            item-text="text"
            item-value="value"
            rounded
            filled
            dense
            hide-details
            style="max-width: 120px; font-size: 12px; margin-left: auto;"
          ></v-select>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text v-show="messageTypeSelection === 'link'">
        <div v-if="smsContentValue === 'Custom'" class="custom-sms-preview">
          <span class="custom-sms-preview-label">{{ $t('modals.findByNumbersModal.customSmsPreview') }}</span>
          <textarea
            class="custom-sms-preview-text custom-sms-field"
            v-model="customSmsText"
            rows="2"
          ></textarea>
        </div>
        <h6 class="pick-list-title">{{ $t('modals.findByListModal.pickListTitle') }}</h6>
      </v-card-text>
      <v-container v-show="messageTypeSelection === 'link'" class="numbers-container">
        <div 
          class="number-item"
          v-for="(list, i) in callListTeams"
          :key="i"
        >
          <div class="checkbox-container">
            <input 
              type="checkbox" 
              v-bind:value="list.id" 
              v-model="listId" 
              @click="toggleTeam"
              class="list-checkbox"
            >
            <span class="number-text">{{ list["callListName"] }}</span>
          </div>
        </div>
      </v-container>
      <v-card-text v-show="messageTypeSelection === 'alert'" class="alert-mode-section">
          <span v-if="weaLink" class="input-group-field wea-link-field">{{ weaLink }}</span>
          <div v-if="weaLink" class="wea-link-actions">
              <v-btn small color="secondary" @click="copyWeaLink">{{ $t('modals.addNumbersModal.copyLink') }}</v-btn>
          </div>
          <div v-if="weaLink" class="dispatcher-link-section">
              <input
                  type="text"
                  class="input-group-field dispatcher-link-title-field"
                  v-model="newLinkTitle"
                  :placeholder="$t('modals.findByNumbersModal.addLinkTitlePlaceholder')"
              >
              <textarea
                  class="input-group-field dispatcher-link-field"
                  v-model="newLink"
                  rows="2"
                  :placeholder="$t('modals.findByNumbersModal.addLinkPlaceholder')"
              ></textarea>
              <v-btn
                  small
                  color="primary"
                  class="save-agency-link-btn"
                  :loading="agencyLinkSaving"
                  :disabled="!newLink.trim() || agencyLinkSaving"
                  @click="saveAgencyLandingLink"
              >
                  {{ agencyLinkSaved ? $t('modals.findByNumbersModal.agencyLinkSaved') : $t('modals.findByNumbersModal.saveAgencyLink') }}
              </v-btn>
          </div>
          <br/>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn medium color="secondary" @click="cancelModal">{{ $t('modals.findByListModal.cancel') }}</v-btn>
        <v-spacer />
        <v-btn v-if="messageTypeSelection === 'link'" medium class="text-none" @click="submitNumbers('whatsapp')" style="color: white; background-color:green;">{{ $t('modals.findByListModal.sendWhatsApp') }}</v-btn>
        <v-btn v-if="messageTypeSelection === 'link'" medium @click="submitNumbers('standard')" color="primary">{{ $t('modals.findByListModal.sendSms') }}</v-btn>
        <v-btn v-if="messageTypeSelection === 'alert' && !weaLink" medium @click="createWEALink" color="primary">{{ $t('modals.findByNumbersModal.getLink') }}</v-btn>
        <v-btn v-if="messageTypeSelection === 'alert' && weaLink" medium @click="closeModal" color="primary">{{ $t('modals.findByNumbersModal.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script lang="js">
import Vue from 'vue'
import store from '@/store'
import { getCallListsByTeam, getTeamNumbers } from '@/services/call-list'
import { saveAlertPortalAgencyLink } from '@/services/location-request'
import {eventBus} from "@/main";

export default Vue.extend({
  data() {
      return {
        isModalShowing: false,
        callListTeams: [],
        newLists: '',
        clTeamId: 0,
        teamId: 0,
        listId: [],
        isClicked: false,
        numbers: [],
        newLink: '',
        newLinkTitle: '',
        agencyLinkSaving: false,
        agencyLinkSaved: false,
        languageValues: ['English', 'Spanish', 'Portuguese', 'French', 'Mandarin', 'German', 'Italian'],
        smsContentValues: ['Standard', 'Custom'],
        smsContentValue: 'Standard',
        customSmsText: '',
      }
  },
  created() {
    this.teamId = store.state.authentication.teams[0]["id"];
    this.getCallListsByTeam();
  },
  methods: {
    openModal() {
      this.isModalShowing = true
    },
    cancelModal() {
      this.isModalShowing = false
      window.location.reload()
    },
    async submitNumbers(deliveryMethod) {
      store.commit('location/callList', this.numbers)
      store.commit('location/setDeliveryMethod', deliveryMethod)
      store.dispatch('location/requestMultipleLocations')
      eventBus.$emit('startNumbersSearch')
      this.isModalShowing = false
    },
    async getCallListsByTeam() {
      const { data } = await getCallListsByTeam(this.teamId)
      this.callListTeams = data
    },
    async commitListNumbers() {
      const { data }  = await getTeamNumbers(this.listId)
      for (let [k, v] of Object.entries(data)) {
        this.numbers.push(data[k]["phoneNumber"])
      }
    },
    toggleTeam() {
      this.isClicked = !this.isClicked
    },
    async copyWeaLink() {
      if (this.weaLink) {
        await navigator.clipboard.writeText(this.weaLink)
      }
    },
    async createWEALink() {
      store.dispatch('location/createWeaLink', this.teamId)
    },
    async saveAgencyLandingLink() {
      const uuid = store.state.location.connectionRequest?.uuid
      if (!uuid || !this.newLink.trim()) return
      this.agencyLinkSaving = true
      this.agencyLinkSaved = false
      try {
        await saveAlertPortalAgencyLink({
          connectionRequestUuid: uuid,
          link: this.newLink,
          title: this.newLinkTitle,
        })
        this.agencyLinkSaved = true
      } finally {
        this.agencyLinkSaving = false
      }
    },
    closeModal() {
      this.isModalShowing = false
    },
  },
  watch: {
    isModalShowing(isOpen) {
      if (isOpen) {
        const lang = this.smsLanguageForLocale
        store.commit('location/setLanguage', lang)
        store.commit('location/setDeepLLanguage', lang)
        this.smsContentValue = 'Standard'
        this.customSmsText = ''
        store.commit('location/setCustomSmsText', '')
      }
    },
    smsContentValue(value) {
      if (value === 'Custom') {
        this.customSmsText = store.state.location.customSmsText || ''
      }
    },
    customSmsText(value) {
      if (this.smsContentValue === 'Custom') {
        store.commit('location/setCustomSmsText', value)
      }
    },
    listId(oldVal, newVal) {
      if(newVal !== null && this.isClicked) {
        eventBus.$emit('addUserList', this.listId)
        this.commitListNumbers()
      }
      else if(oldVal !== null && newVal === null) {
        this.listId = ''
      }
      else{
        null
      }
    }
  },
  computed: {
        smsLanguageForLocale() {
            const locale = this.$i18n?.locale || 'en'
            const map = { en: 'English', es: 'Spanish', pt: 'Portuguese', fr: 'French', de: 'German', it: 'Italian' }
            return map[locale] || 'English'
        },
        languageItems() {
            const keys = { English: 'english', Spanish: 'spanish', Portuguese: 'portuguese', French: 'french', Mandarin: 'mandarin', German: "german", Italian: "italian" }
            return this.languageValues.map(value => ({
                value,
                text: this.$t(`modals.languages.${keys[value]}`),
            }))
        },
        smsContentItems() {
            const keys = { Standard: 'standard', Custom: 'custom' }
            return this.smsContentValues.map(value => ({
                value,
                text: this.$t(`modals.smsContentValues.${keys[value]}`),
            }))
        },
        picked: {
            get() {
                return store.state.location.language
            },
            set(value) {
                store.commit(`location/setLanguage`, value)
                store.commit(`location/setDeepLLanguage` , value)
            }
        },
        messageTypeSelection: {
            get() {
                return store.state.location.overwatchMessageType
            },
            set(value) {
                store.commit('location/setOverwatchMessageType', value)
            }
        },
        teamId() {
            return store.state.authentication.teams[0].id;
        },
        weaLink() {
            return store.state.location.weaLink;
        },
    }
})
</script>

<style scoped>

.input-group-field {
  width: 100%;
  max-width: 45rem;
  padding: 1em;
  margin: 1em auto;
  background-color: lightgray;
  color: black;
  box-shadow: 0px .25rem 1rem rgba(black, .50);
  border-radius: 5px;
  outline: none;
}

.alert-mode-section {
  text-align: center;
  padding: 16px 24px 20px;
  min-height: 56px;
  box-sizing: border-box;
}

.wea-link-field {
  display: block;
  padding: 0.5em 0.75em;
  margin: 0.75em auto 0;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 500;
  word-break: break-all;
  user-select: all;
  cursor: default;
}

.wea-link-actions {
  margin-top: 10px;
}

.dispatcher-link-section {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #ddd;
}

.dispatcher-link-title-field,
.dispatcher-link-field {
  display: block;
  width: 100%;
  max-width: 45rem;
  margin: 0 auto;
  padding: 0.5em 0.75em;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 500;
  text-align: center;
  background-color: lightgray;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
  border-radius: 5px;
  border: none;
  box-sizing: border-box;
  font-family: inherit;
}

.dispatcher-link-title-field {
  height: 3em;
  min-height: 3em;
  max-height: 3em;
  margin-bottom: 9px;
}

.dispatcher-link-field {
  height: 3em;
  min-height: 3em;
  max-height: 3em;
  resize: none;
  overflow: hidden;
}

.save-agency-link-btn {
  margin-top: 10px;
}

.numbers-container {
  overflow-y: auto;
  max-height: 300px;
  padding: 10px 24px 60px 24px !important;
}

.number-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin-bottom: 6px;
  background-color: #f5f5f5;
  border-radius: 5px;
  transition: all 0.2s ease;
}

.number-item:last-child {
  margin-bottom: 0;
}

.checkbox-container {
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
}

.list-checkbox {
  margin-right: 12px;
  cursor: pointer;
}

.number-text {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  flex: 1;
  text-align: left;
  letter-spacing: 0.3px;
}

.v-dialog>.v-card>.v-card__text {
  padding: 0 24px 0 24px;
}

.message-type-section {
  padding: 20px 24px 12px 24px !important;
}

.message-type-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.message-type-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-weight: 300;
}

.message-type-option:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.message-type-option.active {
  background-color: rgba(25, 118, 210, 0.08);
}

.message-type-radio {
  margin-right: 8px;
  cursor: pointer;
}

.message-type-label {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  user-select: none;
}

.message-type-option.active .message-type-label {
  color: #1976d2;
  font-weight: 600;
}

.pick-list-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0;
  padding: 12px 24px 0;
}

.custom-sms-preview {
  margin: 12px 0 4px;
  padding: 10px 12px;
  background-color: #f5f5f5;
  border-radius: 5px;
  text-align: left;
  box-sizing: border-box;
  width: 100%;
}

.custom-sms-preview-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 6px;
}

.custom-sms-preview-text {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
}

.custom-sms-field {
  display: block;
  width: 100%;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  font-family: inherit;
  overflow: hidden;
}

</style>
